<template>
  <div class="statement-detail">
    <a-space class="detail-page" direction="vertical">
      <a-card>
        <h1 class="page-title">
          {{ $t('statementDetails') }}
        </h1>
        <a-descriptions :column="3" bordered>
          <a-descriptions-item :label="$t('accountCode')">
            {{ masterForm.SHEET_CODE }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('通用_企业')">
            {{ $dt(masterForm, 'TARGET_NAME') }}
          </a-descriptions-item>
<!--          <a-descriptions-item :label="$t('clearingTheSubject')">-->
<!--            {{ $dt(masterForm, 'SETTLE_NAME') }}-->
<!--          </a-descriptions-item>-->
          <a-descriptions-item :label="$t('statementType')">
            {{ $dt(masterForm, 'ACCT_TYPE_NAME') }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('invoiceStatus')">
            {{ $dt(masterForm, 'INVOICE_STATUS_NAME') }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('billStatus')">
            {{ $dt(masterForm, 'OPER_STATUS_NAME') }}
          </a-descriptions-item>
          <a-descriptions-item :label="$dt(masterForm,'ACCT_TYPE_NAME')+$t('inAll')" :span="3">
            <span class="price-item" v-if="priceMap.AMT_RMB">{{$t('rmb')+' : '+ priceMap.AMT_RMB}}</span>
            <span class="price-item" v-if="priceMap.AMT_USD">{{$t('us')+' : '+priceMap.AMT_USD}}</span>
            <span class="price-item" v-if="priceMap.AMT_RUB">{{$t('rouble')+' : '+priceMap.AMT_RUB}}</span>
          </a-descriptions-item>
        </a-descriptions>
      </a-card>

      <a-card :title="$t('statementDetailed')">
        <template #extra>
          <a-space>
            <!--对账完成-->
            <template v-if="Number(masterForm.OPER_STATUS) === 2">
                <dol-button @click="generateFile(masterForm.MASTER_ID)" :title="$t('downLoadSettleOrder')">
                  <a-icon type="download"/>
                </dol-button>
              </template>
          </a-space>
        </template>
        <dol-list
          :card-flag="false"
          source="local"
          :default-data="dataList"
          :columns="columns"
          :row-key="'FLOW_ID'"
          :row-index="false"
          :pagination="false"
          ref="list">

          <template #PAY_CURRENCY="field, record">
            <div>{{ field }}</div>
          </template>
          <template #PAY_AMT="field, record">
<!--            <a-input v-if="stateFlag" v-model.trim="field" @change="e => handleChange(e.target.value, record, 'PAY_AMT')"></a-input>-->
            <div>{{ field }}({{record.PAY_CURRENCY_NAME}})</div>
          </template>

          <template #SHOULD_AMT="field, record">
<!--            <a-input v-if="stateFlag" v-model.trim="field" @change="e => handleChange(e.target.value, record, 'PAY_AMT')"></a-input>-->
            <div>{{ field }}({{record.CURRENCY_NAME}})</div>
          </template>

          <template #BOX_CODE="field, record, index">
            <div style="max-width: 400px">
              {{modeFlag[index] ? record.BOX_CODE : record.BOX_CODE?.split(',').slice(0,2).join(',')}}
              <a style="margin-left: 4px" v-if="record.BOX_CODE?.split(',').length>2" @click="changeModeFlag(index)">
                {{modeFlag[index] ? $t('packUp') : $t('more')}}
              </a>
            </div>
          </template>

          <template #LAST_PAY_DATE="field, record">
<!--            <a-input v-if="stateFlag" v-model.trim="field" @change="e => handleChange(e.target.value, record, 'PAY_AMT')"></a-input>-->
            <div>{{ field ? $moment(field).format('YYYY-MM-DD') : '' }}</div>
          </template>

          <template #operation="field, record">
          </template>
        </dol-list>
      </a-card>
    </a-space>

    <!-- 添加对冲账弹窗 -->
    <a-modal v-model.trim="addVisible" width="60%" :title="$t('addHedgeOrder')" :okText="$t('confirm')"
             :cancelText="$t('cancel')" destroyOnClose @ok="saveCharge">
      <dol-form-model class="dol-edit-form" :model="accountOrderForm" :rules="accountValidateRules"
                      ref="accountOrderForm">
        <a-row>
          <a-col :span="11">
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('通用_企业')" prop="SETTLE_ID">
              <dol-select
                v-if="masterForm.SHEET_TYPE != '10062014'"
                v-model.trim="accountOrderForm.TARGET_ID"
                source="server"
                server-type="DotNet"
                dot-net-table-name="GM_COMPANY"
                :label-field="$kt('COMPANY_NAME')"
                key-field="COMPANY_ID"
                value-field="COMPANY_ID"
                :query-data="$api.commonCondition.default0"
                disabled
              />
              <dol-select
                v-else
                v-model.trim="accountOrderForm.TARGET_ID"
                source="server"
                server-type="DotNet"
                dot-net-table-name="BM_SPACE"
                :label-field="$kt('SPACE_NAME')"
                key-field="SPACE_ID"
                value-field="SPACE_ID"
                width="300px"
                disabled
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="11" offset="2">
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('clearingTheSubject')"
                               prop="SETTLE_ID">
              <dol-select
                v-model.trim="accountOrderForm.SETTLE_ID"
                width="100%"
                source="server"
                server-type="DotNet"
                dot-net-table-name="GM_SETTLE"
                label-field="SETTLE_NAME"
                key-field="SETTLE_ID"
                value-field="SETTLE_ID"
                disabled
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('typeOfReceivables')"
                               prop="ACCT_TYPE">
              <a-radio-group disabled v-model.trim="accountOrderForm.ACCT_TYPE">
                <a-radio :value="0">
                  {{ $t('pay') }}
                </a-radio>
                <a-radio :value="1">
                  {{ $t('get') }}
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" offset="2">
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('costTypes')"
                               prop="CHARGE_ID">
              <dol-select
                v-model.trim="accountOrderForm.CHARGE_ID"
                source="server"
                server-type="DotNet"
                dot-net-table-name="BM_BASE_CODE"
                :label-field="$kt('CODE_NAME')"
                key-field="CODE_ID"
                value-field="CODE_ID"
                :query-data="$api.baseCode['10000005']"
                disabled
                style="width: 100%"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('currency')"
                               prop="CURRENCY_ID">
              <dol-select
                v-model.trim="accountOrderForm.CURRENCY_ID"
                source="server"
                server-type="DotNet"
                dot-net-table-name="GM_CURRENCY"
                :label-field="$kt('CURRENCY_NAME')"
                key-field="CURRENCY_NAME"
                value-field="CURRENCY_ID"
                disabled
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="11" offset="2">
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('money')" prop="CHARGE_AMT">
              <a-input-number v-model.trim="accountOrderForm.CHARGE_AMT"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </dol-form-model>
    </a-modal>

    <!-- 选择费用单 -->
    <a-modal v-model.trim="editVisible" centered width="1200px" :okText="$t('confirm')" :cancelText="$t('cancel')"
             :title="$t('selectDetail')" @ok="confirmCheckOrder()">
      <div style="max-height: 400px;overflow-y: auto;">
        <table class="account-table">
          <thead style="position: sticky;top: 0;z-index: 3;">
          <tr>
            <th>
              <a-checkbox v-model.trim="checkAllFlag" @change="checkAll"></a-checkbox>
            </th>
            <th>{{ $t('orderCode') }}</th>
            <th>{{ $t('通用_企业名称') }}</th>
            <th>{{ $t('clearingTheSubject') }}</th>
            <th>{{ $t('typeOfReceivables') }}</th>
            <th>{{ $t('currency') }}</th>
            <th>{{ $t('amountReceivable') }}</th>
            <!--            <th>{{ $t('operate') }}</th>-->
          </tr>
          </thead>
          <tbody class="account-table-body" v-for="(item,index) in detailList" :key="index">
          <div style="height: 10px;"></div>
          <tr class="account-item-header">
            <td colspan="12" nowrap>{{ $dt(item, 'VOUCHER_TYPE_NAME') }} （{{ item.VOUCHER_CODE }}）</td>
          </tr>

          <tr class="account-item-content" v-for="(order,dIndex) in item.DETAIL" :key="dIndex">
            <td>
              <a-checkbox :disabled="!!order.CHECK_STATUS" @change="changeOrder(order)"
                          :checked="checkFlagFuc(order)"></a-checkbox>
            </td>
            <td>{{ order.SHEET_CODE }}</td>
            <td>{{ $dt(order, 'TARGET_NAME') }}</td>
            <td>{{ $dt(order, 'SETTLE_NAME') }}</td>
            <td>{{ $dt(order, 'ACCT_TYPE_NAME') }}</td>
            <td>{{ $dt(order, 'CURRENCY_NAME') }}</td>
            <td>{{ order.SHEET_AMT }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </a-modal>

    <!-- 单行结算详情 -->
    <a-modal v-model.trim="settleVisible" width="60%" :title="$t('settlementDetails')" :okText="$t('confirm')"
             :cancelText="$t('cancel')" destroyOnClose @ok="settle">
      <a-descriptions :column="3" bordered style="margin-bottom: 24px">
        <a-descriptions-item :label="$t('costTypes')">
          {{ detailForm.CHARGE_NAME }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('通用_企业')">
          {{ $dt(masterForm, 'TARGET_NAME') }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('clearingTheSubject')">
          {{ $dt(masterForm, 'SETTLE_NAME') }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('statementType')">
          {{ $dt(masterForm, 'ACCT_TYPE_NAME') }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('money')">
            {{ detailForm.PAY_AMT }}（{{detailForm.PAY_CURRENCY_NAME}})
        </a-descriptions-item>
        <a-descriptions-item :label="$t('paymentMethod')">
          {{ $dt(detailForm, 'PAY_WAY_NAME') }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('invoiceStatus')">
          {{ $dt(detailForm, 'CHECK_STATUS_NAME') }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('settleStatus')">
          {{ $dt(detailForm, 'PAY_STATUS_NAME') }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('invoiceStatus')">
          {{ $dt(masterForm, 'INVOICE_STATUS_NAME') }}
        </a-descriptions-item>
      </a-descriptions>
      <dol-form-model style="width: 50%" :model="settleForm" :rules="settleValidateRules" ref="settleForm">
        <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('receivedDate')"
                           prop="PAY_DATE">
          <dol-date v-model.trim="settleForm.PAY_DATE" width="100%"/>
        </a-form-model-item>
      </dol-form-model>
    </a-modal>

    <a-modal :title="$t('receivedDate')" v-model.trim="allSettleVisible" @ok="allSettle()" @cancel="settleForm=''">
      <dol-form-model :model="settleForm" :rules="settleValidateRules" ref="settleForm">
        <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('receivedDate')"
                           prop="PAY_DATE">
          <dol-date v-model.trim="settleForm.PAY_DATE" width="100%"/>
        </a-form-model-item>
      </dol-form-model>
    </a-modal>
  </div>
</template>

<script>
const MD_FORMAT = 'MMDD';

export default {
  name: "statementDetail",
  data() {
    return {
      checkAllFlag: false,
      changeOrderList: [],
      masterForm: {},
      dataList: [],
      stateFlag: false,
      addVisible: false,
      editVisible: false,
      accountOrderForm: {},
      loading: true,
      accountValidateRules: {
        SETTLE_ID: [{required: true, message: this.$t('pleaseSelectTheSettlementEntity'), trigger: ['blur', 'change']}],
        D_SETTLE_ID: [{
          required: true,
          message: this.$t('pleaseSelectTheSettlementEntity'),
          trigger: ['blur', 'change']
        }],
        ACCT_TYPE: [{required: true, message: this.$t('pleaseSelectThePayableType'), trigger: ['blur', 'change']}],
        CHARGE_ID: [{required: true, message: this.$t('pleaseSelectTheFeeType'), trigger: ['blur', 'change']}],
        CURRENCY_ID: [{
          required: true,
          message: this.$t('pleaseSelectTheCurrencyPayable'),
          trigger: ['blur', 'change']
        }],
        CHARGE_AMT: [{required: true, message: this.$t('pleaseSelectTheAmountPayable'), trigger: ['blur', 'change']}],
        ACCT_DATE: [{required: true, message: this.$t('pleaseSelectThePaymentDate'), trigger: ['blur', 'change']}],
        PAY_CURRENCY_ID: [{
          required: true,
          message: this.$t('pleaseSelectTheActualPaymentCurrency'),
          trigger: ['blur', 'change']
        }],
        PAY_AMT: [{
          required: true,
          message: this.$t('pleaseSelectTheActualPaymentAmount'),
          trigger: ['blur', 'change']
        }],
      },
      settleVisible: false,

      detailList: [],
      detailForm: {},
      settleForm: {},
      settleValidateRules:{
        PAY_DATE: [{required: true, message: this.$t('dateOfArrivalHint'), trigger: ['blur', 'change']}],
      },
      allSettleVisible: false,
      modeFlag: [],
      r_dataList: []
    }
  },
  computed: {
    priceMap() {
      let amtMap = {
        AMT_RMB: 0,
        AMT_USD: 0,
        AMT_RUB: 0,
      };
      this.r_dataList.forEach(item => {
        amtMap['AMT_' + item.CURRENCY_NAME_ENG] += item.SHOULD_AMT
      })
      return amtMap;
    },
    columns() {
      let columns = [];
      columns.push({dataIndex: 'RELATION_CODE', title: this.$t('orderID')});
      columns.push({dataIndex: this.$kt('CHARGE_NAME'), title: this.$t('costTypes')});
      columns.push({dataIndex: 'ACCT_DATE', title: this.$t('通用_日期')});
      columns.push({dataIndex: 'BOX_CODE', title: this.$t('通用_箱号'), scopedSlots: {customRender: 'BOX_CODE'}});
      columns.push({dataIndex: this.$kt('BOX_SIZE_NAME'), title: this.$t('通用_箱型')});
      columns.push({dataIndex: 'REAL_QTY', title: this.$t('通用_箱量')});
      columns.push({dataIndex: 'FREE_USE_DAYS', title: this.$t('formFreeContainerPeriod')});
      columns.push({dataIndex: 'TX_DATE', title: this.$t('takeBoxDate')});
      columns.push({dataIndex: 'HX_DATE', title: this.$t('reBoxDate')});
      columns.push({dataIndex: 'CQ_DAYS', title: this.$t('overdueDay')});
      // columns.push({
      //   dataIndex: this.$kt('CURRENCY_NAME'),
      //   title: this.masterForm.ACCT_TYPE === '0' ? this.$t('currencyPayable') : this.$t('currencyPut')
      // });
      columns.push({
        dataIndex: 'SHOULD_AMT', scopedSlots: {customRender: 'SHOULD_AMT'},
        title: this.masterForm.ACCT_TYPE === '0' ? this.$t('amountPayable') : this.$t('amountReceivable')
      });
      if(this.masterForm.ACCT_STATUS === '1') {
        // columns.push({
        //   dataIndex: this.$kt('PAY_CURRENCY_NAME'), scopedSlots: {customRender: 'PAY_CURRENCY'},
        //   title: this.masterForm.ACCT_TYPE === '0' ? this.$t('actualPaymentCurrency') : this.$t('actualGetCurrency')
        // });
        columns.push({
          dataIndex: 'PAY_AMT', scopedSlots: {customRender: 'PAY_AMT'},
          title: this.masterForm.ACCT_TYPE === '0' ? this.$t('amountActuallyPaid') : this.$t('fundsReceived')
        });
      }
      columns.push({
        dataIndex: 'LAST_PAY_DATE',
        title: this.$t('receivedDate'),
        scopedSlots: {customRender: 'LAST_PAY_DATE'},
      });
      columns.push({dataIndex: '_id', scopedSlots: {customRender: 'operation'}});

      return columns;
    }
  },
  methods: {
    handleChange(value, record, column) {
      const newData = [...this.dataList];
      const target = newData.find(item => record.FLOW_ID === item.FLOW_ID);
      if (target) {
        target[column] = String(value);
        this.dataList = newData;
      }
    },
    confirmCheckOrder() {
      let condition = {
        MASTER_ID: this.masterForm.MASTER_ID,
        PAY_DATA: []
      };
      this.changeOrderList.forEach(item => {
        condition.PAY_DATA.push({
          OPER_TYPE: 0,
          FLOW_ID: item
        })
      })
      this.$h5Api({
        type: '7016',
        data: [condition],
      }).then(({data}) => {
        this.editVisible = false;
        this.$message.info(this.$t('operateSuccessfully'))
        this.getStatementData();
      })
    },
    checkFlagFuc(data) {
      if (this.changeOrderList.indexOf(data.FLOW_ID) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    changeOrder(data) {
      if (this.changeOrderList.indexOf(data.FLOW_ID) === -1) {
        this.changeOrderList.push(data.FLOW_ID)
      } else {
        this.changeOrderList = this.changeOrderList.filter(val => data.FLOW_ID !== val)
      }
    },
    checkAll() {
      if (this.checkAllFlag) {
        this.detailList.forEach(item => {
          item.DETAIL.forEach(order => {
            if (!order.CHECK_STATUS) {
              this.changeOrderList.push(data.FLOW_ID)
            }
          })
        })
      } else {
        this.detailList.forEach(item => {
          item.DETAIL.forEach(order => {
            this.changeOrderList = this.changeOrderList.filter(val => data.FLOW_ID !== val)
          })
        })
      }
    },
    addStatementDetail() {
      this.$h5Api({
        type: '7003',
        data: [{
          "QUERY_TYPE": 0,
          "COMPANY_ID": this.masterForm.TARGET_ID,
          "SHEET_CODE": "",
          "SETTLE_ID": this.masterForm.SETTLE_ID,
          "ACCT_TYPE": this.masterForm.ACCT_TYPE,
          "BEGIN_DATE": this.$moment().startOf('month').format('YYYY-MM-DD'),
          "END_DATE": this.$moment().endOf('month').format('YYYY-MM-DD'),
        }],
      }).then(({data}) => {
        this.detailList = data.PAY_FLOW_INFO;
        this.editVisible = true;
      })
    },
    /*
    * 取消对账单
    * */
    cancelStatement(MASTER_ID) {
      this.$confirm({
        content: this.$t('isCancelStatement'),
        okText: this.$t('confirm'),
        cancelText: this.$t('cancel'),
        onOk: () => {
          this.$h5Api({
            type: '7015',
            data: [{MASTER_ID}],
          }).then(({data}) => {
            this.getStatementList();
            this.$message.info(this.$t('operateSuccessfully'));
          })
        },
        onCancel() {
        },
      });
    },
    /*
    * 对账单确认
    * */
    confirmStatement(MASTER_ID) {
      this.$confirm({
        content: this.$t('isConfirmStatement'),
        okText: this.$t('confirm'),
        cancelText: this.$t('cancel'),
        onOk: () => {
          this.$h5Api({
            type: '7014',
            data: [{MASTER_ID}],
          }).then(({data}) => {
            this.getStatementData();
            this.$message.info(this.$t('operateSuccessfully'));
          })
        },
        onCancel() {
        },
      });
    },
    /*
    * 批量结算
    * */
    allSettle() {
      this.$refs.settleForm.validate(val => {
        if (val) {
          let condition = {
            PAY_TYPE: 0,
            PAY_DATA: [{
              MASTER_ID : this.masterForm.MASTER_ID,
              PAY_DATE: this.settleForm.PAY_DATE
            }]
          };
          this.$h5Api({
            type: '7017',
            data: [condition],
          }).then(({data}) => {
            this.stateFlag = false;
            this.settleForm = {};
            this.allSettleVisible = false
            this.getStatementData();
            this.$message.info(this.$t('operateSuccessfully'))
          })
        }
      })
    },
    addHedgeOrder(data) {
      this.accountOrderForm = Object.assign({},
        {
          ACCT_TYPE: Number(this.masterForm.ACCT_TYPE),
          TARGET_ID: Number(this.masterForm.TARGET_ID),
          SETTLE_ID: Number(this.masterForm.SETTLE_ID)
        }, data);
      this.addVisible = true;
    },
    /*
    * 添加对冲账
    * */
    saveCharge() {
      let condition = {
        "TARGET_ID": this.accountOrderForm.TARGET_ID,
        "SETTLE_ID": this.accountOrderForm.SETTLE_ID,
        "ACCT_TYPE": this.masterForm.ACCT_TYPE,
        "MASTER_ID": this.masterForm.MASTER_ID,
        "FLOW_ID": this.accountOrderForm.FLOW_ID,
        "CURRENCY_ID": this.accountOrderForm.CURRENCY_ID,
        "CHARGE_ID": this.accountOrderForm.CHARGE_ID,
        "CHARGE_AMT": this.accountOrderForm.CHARGE_AMT,
        "MEMO": "",
      };
      this.$refs.accountOrderForm.validate(val => {
        if (val) {
          if (this.loading) {
            this.loading = false;
            this.$h5Api({
              type: '7018',
              data: [condition],
            }).then(({data}) => {
              this.$message.info(this.$t('successfullyAdded'));
              this.addVisible = false;
              this.getStatementData()
            }).finally(e => {
              this.loading = true;
            })
          }
        }
      })
    },
    operateOrder(FLOW_ID, OPER_TYPE) {
      let condition = {
        MASTER_ID: this.masterForm.MASTER_ID,
        PAY_DATA: [{
          FLOW_ID,
          OPER_TYPE
        }]
      };
      this.$h5Api({
        type: '7016',
        data: [condition],
      }).then(({data}) => {
        this.$message.info(this.$t('operateSuccessfully'))
        this.getStatementData();
      })
    },
    getStatementData() {
      this.$h5Api({
        type: '7009',
        data: [{
          MASTER_ID: this.$route.query.MASTER_ID
        }],
      }).then(({data}) => {
        this.formatStatementData(data);
      })
    },
    formatStatementData(data){
      let statementMap = {};
      let statementArr = [];
      data.XV_MASTER?.[0]?.['XV_FLOW_DETAIL'].forEach(item => {
        if(!item.FLOW_ID){
          console.log('费用异常', item);
          return false;
        }
        if (item.PAY_TYPE === 1) {
          item.PAY_AMT = item.ALREADY_AMT;
        } else {
          item.PAY_CURRENCY_ID = item.CURRENCY_ID;
          item.PAY_CURRENCY_NAME = item.CURRENCY_NAME;
          item.PAY_CURRENCY_NAME_ENG = item.CURRENCY_NAME_ENG;
          item.PAY_CURRENCY_NAME_RUS = item.CURRENCY_NAME_RUS;
          item.PAY_AMT = item.SHOULD_AMT;
        }
        statementMap[item.FLOW_ID] = item;
        if (!item.PARENT_FLOW_ID) {
          statementArr.push(item);
        }
      });
      this.r_dataList = data.XV_MASTER?.[0]?.['XV_FLOW_DETAIL']
      data.XV_MASTER?.[0]?.['XV_FLOW_DETAIL'].forEach(item => {
        if (statementMap[item.PARENT_FLOW_ID]) {
          statementArr.map(val => {
            if (!val.children) {
              val.children = [];
            }
            val.children.push(item)
          })
        }
      });
      this.masterForm = data.XV_MASTER?.[0];
      this.dataList = statementArr;
    },

    //下载对账单
    generateFile(MASTER_ID) {
      this.$h5Api({
        type: '7019',
        data: [{MASTER_ID}],
      }).then(({data}) => {
        this.$Dolphin.download(`${this.$t('statement')}_${this.$moment().format(MD_FORMAT)}`, this.$Dolphin.path.filePath + data?.GM_FILE_TEMP[0]?.FILE_NAME)
      });
    },

    downLoadFile(masterForm) {
      this.$Dolphin.download(`${this.$t('statement')}_${this.$moment().format(MD_FORMAT)}`, this.$Dolphin.path.filePath + masterForm?.FILE_NAME)
    },
    settle() {
      this.$refs.settleForm.validate(val => {
        if (val) {
          let condition = {
            FLOW_ID: this.detailForm.FLOW_ID,
            PAY_DATE: this.settleForm.PAY_DATE
          };
          this.$h5Api({
            type: '7020',
            data: [condition],
          }).then(({data}) => {
            this.settleForm = {}
            this.settleVisible = false
            this.getStatementData();
          })
        }
      })
    },
    openSettle(record) {
      this.settleVisible = true;
      this.detailForm = {...record}
    },
    changeModeFlag(index) {
      let list = [...this.modeFlag]
      list[index] = !list[index]
      this.modeFlag = [...list]
    },
  },
  created() {
    if (this.$route.query.MASTER_ID) {
      this.getStatementData();
    }
  }
}
</script>

<style lang="scss">
.statement-detail{
  .price-item{
    font-weight: 700;

    + .price-item{
      &::before{
        content: '、';
      }
    }
  }
}
</style>
